import { render } from "./ItemConfigurationsList.vue?vue&type=template&id=05b63959"
import script from "./ItemConfigurationsList.vue?vue&type=script&lang=js"
export * from "./ItemConfigurationsList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__